module.exports = __webpack_public_path__ + "img/handshake.09012751.png";